import {
  AvatarAccent,
  InitialsAvatar,
  Text,
  Tooltip,
} from "@growtherapy/sprout-ui";
import { Message } from "@twilio/conversations";
import classNames from "classnames";
import { nameToInitials } from "../../utils";
import { parseIdentity } from "../../video-sdk";
import { detectLinks } from "../utils";

export function ChatBubble({
  message,
  isSelf,
}: {
  message: Message;
  isSelf: boolean;
}) {
  const { name } = parseIdentity(message.author ?? "Participant");

  return (
    <li
      className="mb-4 flex gap-3"
      aria-label={`Message from ${isSelf ? "you" : name}`}
    >
      {!isSelf && (
        <Tooltip
          text={name}
          childIsInteractive={false}
          data-dd-privacy="mask"
          className="fs-exclude"
        >
          <InitialsAvatar
            aria-hidden
            size="xs"
            initials={nameToInitials(name)}
            accent={AvatarAccent.Lilac}
          />
        </Tooltip>
      )}
      <div
        className={classNames(
          {
            "max-w-[calc(100%-3rem)]": !isSelf,
            "max-w-full ml-auto": isSelf,
          },
          "flex flex-col",
        )}
      >
        <Text
          variant="sm"
          data-dd-privacy="mask"
          data-dd-action-name="Click on message"
          className={classNames(
            {
              "bg-lilac-700 text-neutral-100 [&>a]:text-neutral-100 rebrand:bg-surface-inverse rebrand:text-text-inverse rebrand:[&>a]:text-text-inverse":
                !isSelf,
              "text-neutral-900 ml-auto bg-neutral-200 rebrand:bg-surface-state-inactive-emphasis rebrand:text-text-default":
                isSelf,
            },
            "rounded-xl px-4 py-3 fs-exclude [&>a]:underline max-w-full break-words",
          )}
        >
          {detectLinks(message.body)}
        </Text>
        <Text variant="xs" className="text-neutral-700 ml-auto pt-1">
          <span className="sr-only">Sent at&nbsp;</span>
          {message.dateCreated?.toLocaleTimeString([], {
            hour: "numeric",
            minute: "numeric",
          })}
        </Text>
      </div>
    </li>
  );
}
